const GroupDropDownOptions = [
  {
    title: "User Management",
    classes: "",
    expandView: true,
    dropDown: [
      {
        title: "User",
        keyName: "user",
        readBy: "readUsers"
      },
      {
        title: "Group",
        keyName: "group",
        readBy: "readGroups"
      },
      {
        title: "Role",
        keyName: "role",
        readBy: "readRoles"
      }
      // {
      //   title: "Best Practices",
      //   keyName: "bestPractices"
      // }
    ]
  }
];

export { GroupDropDownOptions };
